import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozChipsDisplayComponent implements IController {
  isReadonly: any;
  placeholder: string;
  required: any;
  list: any;
  onRemove: Function;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onAdd($chip, $index) {
    const listCopy = angular.copy(this.list);
    listCopy.splice($index, 1)
    this.onChange({list: _.concat(listCopy, {name: $chip})});
  }

  onRemoveItem($chip, $index) {
    this.onChange({list: this.list});
    this.onRemove({chip: $chip});
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozChipsDisplay', {
    require: {
      form: '^form'
    },
    bindings: {
      isReadonly: '<',
      placeholder: '@?',
      required: '<?',
      list: '<',
      onRemove: '&',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-chips-display/bringoz-chips-display.html',
    controller: BringozChipsDisplayComponent
  });
